/**
 *interval timer
 *
 * @class IntervalTimer
 */
class IntervalTimer {
    #timerId;
    start;

    /**
     * Creates an instance of IntervalTimer.
     * @param {*} callback
     * @param {*} delay
     * @memberof IntervalTimer
     */
    constructor(callback, delay) {
        this.delay = delay;
        this.remaining = delay;
        this.callback = callback;

        this.resume();
    }

    /**
     *
     *
     * @memberof IntervalTimer
     */
    pause() {
        window.clearTimeout(this.#timerId);
        this.remaining -= new Date() - this.start;
    }

    /**
     *
     *
     * @memberof IntervalTimer
     */
    resume() {
        this.start = new Date();
        this.#timerId = window.setTimeout(() => {
            this.remaining = this.delay;
            this.resume();
            this.callback();
        }, this.remaining);
    }

    /**
     *
     *
     * @memberof IntervalTimer
     */
    reset() {
        window.clearTimeout(this.#timerId);
        this.resume();
    }
}

export default IntervalTimer;
export { IntervalTimer };
